<template>
  <div class="xy-box" v-if="show" @click="show = false">
  	<div class="xy-box-model" @click.stop>
  		<div class="xy-box-model-title">
  			<span>{{type===1?$t('all.yonghuxieyi'):$t('all.yinsixieyi')}}</span>
			<img src="../../assets/image/wode_jiazu@2x.png" alt="" @click="show = false"/>
  		</div>
		<div class="xy-box-model-container">
			<div class="xy-yszc">{{data}}</div>
		</div>
  	</div>
  </div>
</template>

<script>
import { getHtmlContentByType } from '@/api/user';
export default {
  data() {
    return {
	  show:false,
	  data:'',
	  type:''
    };
  },
  mounted() {
	
  },
  methods: {
	showModel(data){
		this.show = true
		this.type = data
		this.getHtmlContentByType(data)
	},
	//静态页面
	async getHtmlContentByType(data){
		const res = await getHtmlContentByType({type:data})
		this.data = res.data
	}

  }
};
</script>
<style scoped lang="scss">
	@import "./xieyi.css";
</style>


// WEBPACK FOOTER //
// xieyi.vue?64cab6db